interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300/80 bg-background-100/60 px-6 py-16 text-center">
      <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-film-line text-3xl"></i>
      </span>
      <h3 className="text-base font-medium text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-refresh-line text-base"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}